<template>
  <component :is="userData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="userData === undefined">
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link class="alert-link" :to="{ name: 'apps-users-list' }">
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <b-tabs v-if="userData" pills>
      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon icon="UserIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Profiili</span>
        </template>
        <personel-edit-tab-account
          :user-data="userData"
          class="mt-2 pt-75"
          @onSaveChanges="saveChanges"
          @blockUser="onBlockUser"
        />
      </b-tab>

      <!-- Tab: Information -->
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Lisätietoja</span>
        </template>
        <personel-edit-tab-information
          :user-data="userData"
          class="mt-2 pt-75"
          @onSaveChanges="saveChanges"
        />
      </b-tab>

      <!-- Tab: Social -->
      <!-- <b-tab>
        <template #title>
          <feather-icon
            icon="CreditCardIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Bank Details</span>
        </template>
        <personel-edit-bank-details
          :user-data="userData"
          class="mt-2 pt-75"
          @onSaveChanges="saveChanges"
        />
      </b-tab> -->
    </b-tabs>
  </component>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
// eslint-disable-next-line import/no-cycle
import router from '@/shared/router'
import store from '@/shared/store'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import PersonelEditTabAccount from './PersonelEditTabAccount.vue'
import PersonelEditTabInformation from './PersonelEditTabInformation.vue'
import PersonelEditBankDetails from './PersonelEditBankDetails.vue'

const EDITABLE_FIELDS = [
  'firstName',
  'lastName',
  'email',
  'mobile',
  'address',
  'love',
  'drivingLicense',
  'jobTitle',
  'role',
  'profession',
  'status',
  'birthday',
  'hasValvira',
  'carAvailable',
  'fullName',
  'firstName',
  'lastName',
  'isSubcontractor',
  'specials',
]

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    ToastificationContent,
    PersonelEditTabAccount,
    PersonelEditTabInformation,
    PersonelEditBankDetails,
  },
  data() {
    return {
      processer: {},
    }
  },
  beforeCreate() {
    this.$store.dispatch('appAuth/getCurrentUser').then(res => {
      const user = JSON.parse(JSON.stringify(res))
      this.processer = {
        firstName: user.firstName,
        lastName: user.lastName,
      }
    })
  },
  methods: {
    onBlockUser({ blockStatus, blockReason, blockedFrom, userId, callback }) {
      const blocker = `${this.processer.firstName} ${this.processer.lastName}`
      store
        .dispatch('appPersonel/blockUser', {
          blockStatus,
          blockReason,
          blocker,
          blockedFrom,
          userId,
        })
        .then(() => {
          callback()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('success'),
              icon: 'CheckIcon',
              text: 'Käyttäjä estetty',
              variant: 'success',
            },
          })
        })
        .catch(() => {
          callback()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('error'),
              text: this.$t('something_went_wrong'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    saveChanges() {
      this.userData.address.state = this.userData.address.state
        ? this.userData.address.state.toLowerCase()
        : this.userData.address.state

      if (this.userData.loveGranted !== '') {
        EDITABLE_FIELDS.push('loveGranted')
      }

      // Filter out non editable fields
      const edited = Object.keys(this.userData)
        .filter(key => EDITABLE_FIELDS.includes(key))
        .reduce((obj, key) => {
          // eslint-disable-next-line no-param-reassign
          obj[key] = this.userData[key]
          return obj
        }, {})
      store
        .dispatch('appPersonel/updateUser', {
          id: this.userData.uid,
          data: edited,
          isEmailChanged: this.originalUserData.email !== this.userData.email })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('success'),
              icon: 'CheckIcon',
              text: 'Käyttäjä päivitetty',
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('error'),
              text: this.$t('something_went_wrong'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
  setup() {
    const userData = ref(null)
    const originalUserData = ref(null)

    store
      .dispatch('appPersonel/fetchUser', { id: router.currentRoute.params.id })
      .then(response => {
        const blockedFrom = response?.blockedFrom?.map(item => ({ ...item, date: item.date.toDate() }))
        userData.value = { ...response, blockedFrom }
        originalUserData.value = { ...response, blockedFrom }
      })
      .catch(error => {
        if (error.response.status === 404) {
          userData.value = undefined
          originalUserData.value = undefined
        }
      })

    return {
      userData,
      originalUserData
    }
  },
}
</script>

<style></style>
